import { WebPlugin } from '@capacitor/core';
/**
 * Web implementation. The browser has no standardized, broadly-available
 * contacts database API (the Contact Picker API is limited, gated, and
 * read-only), so every method throws `unimplemented()`. The plugin is
 * native-only on iOS and Android.
 */
export class ContactsWeb extends WebPlugin {
    async find(_options) {
        throw this.unimplemented('Contacts.find() is not available on web.');
    }
    async save(_options) {
        throw this.unimplemented('Contacts.save() is not available on web.');
    }
    async remove(_options) {
        throw this.unimplemented('Contacts.remove() is not available on web.');
    }
    async pickContact() {
        throw this.unimplemented('Contacts.pickContact() is not available on web.');
    }
}
//# sourceMappingURL=web.js.map